import { Button } from '@cian/ui-kit/button';
import { IconMap16 } from '@cian/ui-kit/icons';
import * as React from 'react';
import { createPortal } from 'react-dom';

import * as styles from './OnMapButton.css';
import { ETestId } from '../../../common/constants/testId';

interface IOnMapButtonProps {
  onClick(): void;
}

export const OnMapButton = (props: IOnMapButtonProps) => {
  return createPortal(
    <div className={styles['on-map']}>
      <Button
        onClick={props.onClick}
        theme="fill_white_primary"
        beforeIcon={<IconMap16 color="primary_100" />}
        data-testid={ETestId.OnMapButton}
      >
        На карте
      </Button>
    </div>,
    document.body,
  );
};
